module.exports = __webpack_public_path__ + "img/empty.e7f939ba.png";